/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { elementHasClassName } from './util.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MPlugins } from './plugins.js';

import { MDMedia } from './media-data.js';
import { MDObject } from './object-data.js';
import { MThumbnails } from './thumbnails.js';

import { MVTrees } from './trees.js';

import { MVDownload } from './download.js';
import { MVSearch } from './search.js';
import { Lightbox } from './lightbox.js';



export let MVResult = function($) {
	var m_root = null;
	var m_mvdetail_open = null;
	var m_widget = null;

	function init( dyn_id_pfx, root, list_changed, selection_changed, second_click_on_thumbnail, clear_external_selections, view_type_changed, mvdetail_open_fn, result_nodes_loaded, lightbox_enabled ) {
		m_root = root;
		m_mvdetail_open = mvdetail_open_fn || function() { };
		m_root.mjMediaResultViewWidget( {

			dyn_id_pfx,

			buttons_dependent: {
				'lightbox':	['<div class="mmb mm-lbout" title="'+mjt('ctx-menu-lb-out')+'"></div>'],
				'search':	lightbox_enabled ? ['<div class="mmb mm-lbin" title="'+mjt('ctx-menu-lb-in')+'"></div>'] : [],
				'slist':	lightbox_enabled ? ['<div class="mmb mm-lbin" title="'+mjt('ctx-menu-lb-in')+'"></div>'] : [],
			},
			buttons: [
				'<div class="mmb mm-open" title="'+mjt('ctx-menu-open')+'"></div>',
				'<div class="mmb mm-down" title="'+mjt('ctx-menu-download')+'"></div>'
			],
			list_changed: function( evt, data ) {
				list_changed(evt,data);
			},
			selection_changed: function( evt, data ) {
				selection_changed(evt,data.opt_open_whole_list_cb,'MVResult::selection_changed');
			},
			view_type_changed: function( evt, data ) {
				view_type_changed(evt,data.type);
			},
			mvdetail_open_fn: m_mvdetail_open,

			result_nodes_loaded: function( evt, data ) {
				result_nodes_loaded(evt,data);
			},

			lightbox_enabled,

		} );
		m_widget = m_root.mjMediaResultViewWidget('instance');

		// TODO: move this stuff to mjMediaResultViewWidget???
		MDMedia.bindMetaChanged( function mvresult_on_meta_changed( media_ids, meta, trigger_meta_ids ) {
			// start requests for further view status infos through plugins
			MPlugins.callOnAllPluginsOfType('MediaThumbnailView','queryMediaViewStatus',true,'result',media_ids,meta,false);
			$.each( media_ids, function(idx,media_id) {
				const node = m_root.children('.media[data-mj_mid='+media_id+']');
				if( node.length ) {
					m_widget.setItemMetadata( node, media_id, meta[media_id]||{'-1':[0]} );
				}
			} );
		} );
		MPlugins.iterateByType( 'MediaThumbnailView', function(name,plugin) {
			plugin.initViewNodesRoot( 'result', m_root, function(e,action) {
				if( action==='annotations' ) {
					const node = $(e.target).closest('.media');
					const media_id = node.data('media_id');
					if( media_id ) {
						m_mvdetail_open( [media_id], 'annotations', 0, m_widget.getListCount()>1 ? openWholeResultInDetailView : null );
					}
				}
			} );
			plugin.bindStatusChanged( 'result', function( media_ids, meta ) {
				$.each( media_ids, function(idx,media_id) {
					const node = m_root.children('.media[data-mj_mid='+media_id+']');
					if( node.length ) {
						m_widget.setItemMetadata( node, media_id, meta[media_id]||{'-1':[0]} );
					}
				} );
			} );
		} );
		MDMedia.bindCategoriesChanged( function mvresult_on_categories_changed( media_ids, categories ) {
			$.each( media_ids, function(idx,media_id) {
				const node = m_root.children('.media[data-mj_mid='+media_id+']');
				if( node.length ) {
					m_widget.setItemCategories( node, media_id, categories[media_id]||{} );
				}
			} );
		} );

		MDMedia.bindMediaDeleted( function mvresult_on_media_deleted( media_ids ) {
			const wrappedListType = m_widget.getWrappedListType();
			$.each( media_ids, function(idx,media_id) {
				if( wrappedListType==='lightbox' ) {
					m_root.children('.media[data-mj_mid='+media_id+']')
						.removeClass('new reload undel')//.addClass('deleted')
						.off('contextmenu')
						// .find('.media_id').text(mjt('deleted-media-id','!')).end()
						.find('> .mmu > .media_menu').find('>div.mm-down,>div.mm-open').hide().end().end()
						.find('.media-overlay-1,.media-overlay-2').remove().end()
						.find('[meta_id]').empty().end()
						.children('.thumbnail')
						.removeClass('loading ui-selected ui-selecting')
						.stop(true)
						.off()
						.empty();
				} else {
					m_root.children('.media[data-mj_mid='+media_id+']')
						.removeClass('new reload undel')//.addClass('deleted')
						.off('contextmenu')
						.find('.media_id').text(mjt('deleted-media-id','!')).end()
						.find('> .mmu > .media_menu > div.mmb').remove().end()
						.find('.media-overlay-1,.media-overlay-2').remove().end()
						.find('[meta_id]').empty().end()
						.children('.thumbnail')
						.removeClass('loading ui-selected ui-selecting')
						.stop(true)
						.off()
						.empty();
				}
			} );
		} );

		MDMedia.bindMediaRestored( function mvresult_on_media_restored( media_ids, data ) {
			// const wrappedListType = m_widget.getWrappedListType();
			// console.log({w:'RESULT bindMediaRestored',media_ids,data,wrappedListType});

			// start requests for further view status infos through plugins
			const meta = data.meta ?? {};
			// const categories = data.categories ?? {};
			MPlugins.callOnAllPluginsOfType('MediaThumbnailView','queryMediaViewStatus',true,'result',media_ids,meta,false);
			$.each( media_ids, function(idx,media_id) {
				const node = m_root.children('.media[data-mj_mid='+media_id+']');
				if( node.length ) {
					m_widget.restoreDeletedNode( node, function() {
						// console.log({w:'restoreDeletedNode on_after_update'});
					});
					// m_widget.setItemMetadata( node, media_id, meta[media_id]||{'-1':[0]} );
					// m_widget.setItemCategories( node, media_id, categories[media_id]||{} );
				}
			} );


		} );

		MDObject.bindObjectAttributesChanged( function mvresult_on_object_attributes_changed( object_type, object_id, attributes, item_count ) {
			const widgetListType = m_widget.getListType();
			if( widgetListType===object_type && m_widget.getObjectId()===object_id ) {
				m_widget.listChanged();
			} else {
				const wrappedWidgetSource = m_widget.getWrappedSource();
				const wrappedWidgetSourceListType = wrappedWidgetSource.getListType();
				if( wrappedWidgetSourceListType===object_type && wrappedWidgetSource.getObjectId()===object_id ) {
					m_widget.listChanged();
				}
			}
		});
		MDObject.bindObjectDeleted( function mvresult_on_object_deleted( object_type, object_id ) {
			const widgetListType = m_widget.getListType();
			if( widgetListType===object_type && m_widget.getObjectId()===object_id ) {
				MVSearch.loadCurrentSearchResultIntoResultView();
			} else {
				const wrappedWidgetSource = m_widget.getWrappedSource();
				const wrappedWidgetSourceListType = wrappedWidgetSource.getListType();
				if( wrappedWidgetSourceListType===object_type && wrappedWidgetSource.getObjectId()===object_id ) {
					MVSearch.loadCurrentSearchResultIntoResultView();
				}
			}
		});
		MDObject.bindObjectItemListChanged( function mvresult_on_object_item_list_changed( object_type, object_id, object_item ) {
			const widgetListType = m_widget.getListType();
			if( widgetListType===object_type && m_widget.getObjectId()===object_id ) {
				m_widget.loadObject(object_type,object_id,object_item,null);
			} else {
				const wrappedWidgetSource = m_widget.getWrappedSource();
				const wrappedWidgetSourceListType = wrappedWidgetSource.getListType();
				if( wrappedWidgetSourceListType===object_type && wrappedWidgetSource.getObjectId()===object_id ) {
					m_widget.loadObject(object_type,object_id,object_item,null);
				}
			}
		});

		$(document)
			.on( 'mjsrecreatethumbnails.MVResult', function(e,media_id,meta) {
				var m = m_root.children('.media[data-mj_mid='+media_id+']');
				if( m.length ) {
					var thumb = m.find('.thumbnail');
					var iw = m_widget.getThumbW();
					var ih = m_widget.getThumbH();
					MThumbnails.createOnTarget(
						thumb[0],
						{
							media_id: media_id,
							width: iw,
							height: ih,
							meta: meta,
							thumb_loader_anim: 'precreated',
						}
					);
					thumb.append('<div class="media-overlay-1"></div>');
				}
			} )
			.on( 'mjsrecreatecthumbnails.MVResult', function(e,tree_id,cat_id) {
				var cnode = m_root.children('.category[mj_tree_id='+tree_id+'][mj_cat_id='+cat_id+']');
				if( cnode.length ) {
					var thumb = cnode.find('.cthumbnail'),
						iw = m_widget.getCThumbW(),//thumb.innerWidth()-2,
						ih = m_widget.getCThumbH();//thumb.innerHeight()-2;
					MVTrees.createCategoryThumbnail(tree_id,cat_id,thumb[0],iw,ih);
				}
			} );


		// events on media items
		m_root
			.on( 'click.MVResult', '.thumbnail',
				function( evt ) {
					var i, j, jnode, jxnode;
					// ignore clicks on 'clickable-media-overlay' elements ...
					if( $(evt.target).hasClass('clickable-media-overlay') ) return;

					// remove focus from search (for kbd nav...)
					MVSearch.looseFocus();

					var self = $(this), m = self.closest('.media',m_root[0]);
					if( !elementHasClassName(m[0],'undel') ) {
						self.removeClass('ui-selected');
					} else {
						// unselect all category items
						m_root.find('.cthumbnail').removeClass('ui-selected');
						if( evt.shiftKey ) {
							var idx = parseInt(self.attr('mj_tidx')||self.closest('.media',m_root[0]).attr('mj_tidx'),10),
								nodes = m_root.find('.thumbnail'),
								found = false;
							// search backwards...
							for( i=idx-1; i>=0; i-- ) {
								if( elementHasClassName(nodes[i],'ui-selected') ) {
									for( j=i+1; j<=idx; j++ ) {
										jnode = $(nodes[j]);
										jxnode = jnode.closest('.media');
										if( jxnode.length && elementHasClassName(jxnode[0],'undel') ) jnode.addClass('ui-selected');
									}
									found = true;
									break;
								}
							}
							if( !found ) {
								// search forward...
								var nodes_length = nodes.length;
								for( i=idx+1; i<nodes_length; i++ ) {
									if( elementHasClassName(nodes[i],'ui-selected') ) {
										for( j=idx; j<i; j++ ) {
											jnode = $(nodes[j]);
											jxnode = jnode.closest('.media');
											if( jxnode.length && elementHasClassName(jxnode[0],'undel') ) jnode.addClass('ui-selected');
										}
										break;
									}
								}
							}
						} else if( evt.altKey || evt.ctrlKey ) {
							// console.log({w:'MVResult... click .thumbnail + ( evt.ctrlKey || evt.altKey )', hasClassUiSelected:self.hasClass('ui-selected') });
							self.toggleClass('ui-selected');
						} else {
							// plain click on any other media node -> single select node
							if( clear_external_selections!==null ) clear_external_selections(evt);
							if( !self.hasClass('ui-selected' )) m_root.find('.thumbnail').removeClass('ui-selected');
							self.addClass('ui-selected');
						}
					}
					// ensure, data of all "selected" nodes is loaded ...
					//  (there may be invisible nodes, that are not loaded yet)
					m_widget.updateSelectedNodes( 0, 0, function() {
						m_widget.selectionChanged(evt,'click .thumbnail -> updateSelectedNodes');
					} );
					//return false; -> we want the event later
				} )
			.on( 'dblclick.MVResult', '.thumbnail',
				function( evt ) {
					var self = $(this),
						m = self.closest('.media',m_root[0]);
					if( elementHasClassName(m[0],'undel') ) {
						// single select the node
						if( clear_external_selections!==null ) clear_external_selections(evt);
						m_root.find('.thumbnail,.cthumbnail').removeClass('ui-selected');
						self.addClass('ui-selected');
						m_widget.selectionChanged(evt,'dblclick .thumbnail');
						if( window.MVMediaPage ) window.MVMediaPage.media_action('open');
					}
				} )
			.on( 'click.MVResult', '.mm-lbin',
				function() {
					Lightbox.insert( [ $(this).closest('.media',m_root[0]).data('media_id') ] );
				} )
			.on( 'click.MVResult', '.mm-lbout',
				function() {
					Lightbox.remove( [ $(this).closest('.media',m_root[0]).data('media_id') ] );
				} )
			.on( 'click.MVResult', '.media_id1>.media_id,.mm-open',
				function() {
					m_mvdetail_open( [ $(this).closest('.media',m_root[0]).data('media_id') ], 'detail', 0, m_widget.getListCount()>1 ? openWholeResultInDetailView : null );
				} )
			.on( 'click.MVResult', '.mm-down',
				function() {
					MVDownload.open( [ $(this).closest('.media',m_root[0]).data('media_id') ] );
				} )

			// events on category items
			.on( 'click.MVResult', '.cthumbnail,.category_title1',
				function( evt ) {
					// remove focus from search (for kbd nav...)
					MVSearch.looseFocus();
					MVSearch.triggerFilterSetCategory(null,$(this).closest('.category',m_root[0]).attr('mj_cat_id'));
				} )
			.on( 'dblclick.MVResult', '.cthumbnail',
				function( evt ) {
					var self = $(this);
					// unselect all other nodes
					if( clear_external_selections!==null ) clear_external_selections(evt);
					m_root.find('.thumbnail,.cthumbnail').removeClass('ui-selected');
					// select the node
					self.addClass('ui-selected');
					m_widget.selectionChanged(evt,'dblclick .cthumbnail');
					// go into category
					MVSearch.triggerFilterSetCategory(null,self.closest('.category',m_root[0]).attr('mj_cat_id'));
				} );
	}


	function loadSource( source, object_item, load_all, done_cb ) {
		return m_widget.loadSource(source,object_item,load_all,done_cb);
	}
	function loadSearchResult( list_id, tree_id, cat_id, list_count, load_all ) {
		return m_widget.loadSearchResult(list_id,tree_id,cat_id,list_count,load_all);
	}
	function loadSearchList( list_id, list_count, load_all ) {
		return m_widget.loadSearchList(list_id,list_count,load_all);
	}
	function loadObject( type, object_id, object_item, load_all, done_cb ) {
		return m_widget.loadObject(type,object_id,object_item,load_all,done_cb);
	}
	function loadEmpty( type, done_cb ) {
		return m_widget.loadEmpty(type,done_cb);
	}

	function setViewSize( size, stopped ) {
		return m_widget.setViewSize(size,stopped);
	}
	function setViewType( type, save, done_cb ) {
		var r = m_widget.setViewType(type,save);
		if( done_cb ) done_cb(type,save);
		return r;
	}

	function actionOnWholeResult( callback ) {
		return m_widget.actionOnWholeResult(callback);
	}
	function openWholeResultInDetailView( done_cb, mode ) {
		return m_widget.openWholeResultInDetailView(done_cb,mode);
	}
	function selectionChanged( evt, calledFrom ) {
		return m_widget.selectionChanged(evt,(calledFrom??'')+' -> MVResult::selectionChanged');
	}
	function getVisibleResultsCount() {
		return m_widget.getVisibleResultsCount();
	}

	function selectVisibleNodes( media_ids, replace_selection, scroll_into_view ) {
		return m_widget.selectVisibleNodes(media_ids,replace_selection,scroll_into_view);
	}

	function getVisibleNodeByMediaId( media_id ) {
		return m_widget.getVisibleNodeByMediaId(media_id);
	}
	function getVisibleNodeByTreeIdAndCatId( tree_id, cat_id ) {
		return m_widget.getVisibleNodeByTreeIdAndCatId(tree_id,cat_id);
	}

	function getWidget() {
		return m_widget;
	}

	return {
		init,

		loadSource,
		loadSearchResult,
		loadSearchList,
		loadObject,
		loadEmpty,

		setViewSize,
		setViewType,

		actionOnWholeResult,
		openWholeResultInDetailView,
		selectionChanged,
		getVisibleResultsCount,

		selectVisibleNodes,

		getVisibleNodeByMediaId,
		getVisibleNodeByTreeIdAndCatId,

		getWidget,

		// ,benchmark: function( type ) {
		// 	function _benchmark( type ) {
		// 		console.time('MVResult.benchmark.'+type);
		// 		m_widget.setViewType( type, true, function() {
		// 			m_widget.loadRemainingResult( function() {
		// 				console.timeEnd('MVResult.benchmark.'+type);
		// 			} );
		// 		});
		// 	}
		// 	_benchmark(type);
		// }
	};

}(jQuery); // namespace MVResult
